export default function PageTitle({
  children = "Kết quả xổ số 3 miền hôm nay",
}) {
  return (
    <h1 className="xoso-compound__title">
      <b className="xoso-compound__title-deco" />
      {children}
      <b className="xoso-compound__title-deco" />
    </h1>
  );
}
